import { coerceEmptyStringToUndefined, coerceNullToUndefined } from "./coercions.js";
import { boolean, clone, unknown, preprocess, nullish, tuple } from "zod";
import { NonEmptyString } from "./non-empty-string.js";
/** @import { output, ZodBoolean, ZodPipe, ZodTransform } from "zod" */

const GoogleBool = /** @type {ZodPipe<ZodTransform<boolean, boolean | string>, ZodBoolean>} */ (
  preprocess(
    coerceBoolishToBoolean,
    boolean({
      error: ({ input }) =>
        `A valid boolean cell can only be true, false or the words "true", "false", "yes" and "no" case-insenstive, not: ${input}`,
    }),
  )
);

/**
 * @param {unknown} input
 * @returns {unknown}
 */
function coerceBoolishToBoolean(input) {
  switch (typeof input) {
    case "boolean":
      return input;
    case "string":
      const comparableInput = input.trim().toLocaleLowerCase();
      if (comparableInput === "true" || comparableInput === "yes") return true;
      if (comparableInput === "false" || comparableInput === "no") return false;
      return input;
    default:
      return input;
  }
}

export const MealRow = tuple([
  // 0 - photo
  unknown(), // photo

  // 1 - name
  preprocess(
    coerceEmptyStringToUndefined,
    clone(NonEmptyString, {
      error: () => `Meal name must be provided`,
      type: "string",
    }),
  ),

  // 2 - group name
  nullish(
    clone(NonEmptyString, {
      error: () => `Group name must be text if provided`,
      type: "string",
    }),
  ).transform(coerceNullToUndefined),

  // 3 - key ingredients
  nullish(
    clone(NonEmptyString, {
      error: ({ input }) =>
        `Key ingredients should either be omitted or a list of comma-separated ingredient names, not: ${input}`,
      type: "string",
    }),
  ).transform(coerceNullToUndefined),

  // 4 - source
  preprocess(
    coerceEmptyStringToUndefined,
    nullish(
      clone(NonEmptyString, {
        error: ({ input }) => `Source must be a valid URL or other source, not: ${input}`,
        type: "string",
      }),
    ),
  ).transform(coerceNullToUndefined),

  // 5 - luncheable
  nullish(GoogleBool).transform(coerceNullToUndefined),

  // 6 - contains fish
  nullish(GoogleBool).transform(coerceNullToUndefined),
]);
/** @typedef {output<typeof MealRow>} MealRow */
